import { useCallback } from 'react';
import { InvoiceInfoDto, InvoicePermissions, IPagingData } from '@sr/dto';
import { changeInvoiceCanceledStatus, fetchSupplierInvoices } from '../api';
import { useReadOnlyRemotePagedCollection } from 'utils/remote-paged-collection.hook';
import { useUserAuth } from 'features/auth';

export const useSupplierInvoices = (paging: IPagingData, companyId?: number, searchString?: string) => {
  const { user } = useUserAuth();
  const showAll = user?.permissions.some((p) => p === InvoicePermissions.ANY_CLIENT_INVOICES || p === InvoicePermissions.EDIT_INVOICE);
  const collection = useReadOnlyRemotePagedCollection<InvoiceInfoDto>({
    fetchHandler: useCallback(() => fetchSupplierInvoices(paging, `${searchString}${showAll ? '&showAll=true' : ''}`, companyId), [companyId, paging, searchString, showAll]),
  });

  const changeInvoiceStatus = (id: number) => changeInvoiceCanceledStatus(id);

  return {
    collection,
    changeCancelStatus: changeInvoiceStatus,
  };
};
